import { render, staticRenderFns } from "./FormMainRFQ.vue?vue&type=template&id=a55ff27c&"
import script from "./FormMainRFQ.vue?vue&type=script&lang=js&"
export * from "./FormMainRFQ.vue?vue&type=script&lang=js&"
import style0 from "./FormMainRFQ.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports